import React, { useState, useEffect } from "react";
import { postAPI } from "../../utils/common";
import { REPORTING } from "../../constants/api";
import "./ReportsPage.css";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Card, Layout } from "antd";
const ReportsPage = () => {
  const { Content } = Layout;
  const [reports, setReports] = useState(null);

  const getDefaultStartDate = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
  };

  const getDefaultEndDate = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0)
      .toISOString()
      .slice(0, 10);
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());

  const fetchReports = () => {
    postAPI(
      REPORTING,
      {
        start_date: startDate,
        end_date: endDate,
      },
      (data) => {
        if (data.status) {
          setReports(data.data);
        }
      },
      (err) => console.log(err),
    );
  };

  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Reports"
          extra={
            <>
              <div className="filters">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
                <button onClick={fetchReports}>Filter</button>
              </div>
            </>
          }
        >
          <div className="reports-container">
            {reports ? (
              <>
                <div className="section">
                  <h2>Occupancy Overview</h2>
                  <div className="card-group">
                    <div className="card">
                      <h3>{reports.occupancy_rate}%</h3>
                      <p>Occupancy Rate</p>
                    </div>
                    <div className="card">
                      <h3>{reports.revenue} ₹</h3>
                      <p>Total Revenue</p>
                    </div>
                    <div className="card">
                      <h3>{reports.average_daily_rate} ₹</h3>
                      <p>ADR</p>
                    </div>
                    <div className="card">
                      <h3>{reports.revpar} ₹</h3>
                      <p>RevPAR</p>
                    </div>
                    <div className="card">
                      <h3 style={{ color: "red" }}>
                        ₹ {reports.total_discount_given ?? 0}
                      </h3>
                      <p>Total Discount Given</p>
                    </div>
                  </div>
                </div>
                <div className="card-group">
                  <div className="section">
                    <h2>Booking Status</h2>
                    <ul className="list">
                      {Object.entries(reports.booking_status_count).map(
                        ([key, val]) => (
                          <li key={key}>
                            {key}: {val}
                          </li>
                        ),
                      )}
                    </ul>
                  </div>

                  <div className="section">
                    <h2>Payment Methods</h2>
                    <p>Cash: {reports.payment_methods.cash} ₹</p>
                    <p>Online: {reports.payment_methods.online} ₹</p>
                  </div>

                  <div className="section">
                    <h2>Booking Trends</h2>
                    <ul className="list">
                      {reports.booking_trends.map((trend, i) => (
                        <li key={i}>
                          {trend.date}: {trend.bookings_count} bookings
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="card-group">
                  <div className="section">
                    <h2>Booking Sources</h2>
                    <ul className="list">
                      {reports.booking_sources.map((src, i) => (
                        <li key={i}>
                          {src.booking_source}: {src.count}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="section">
                    <h2>Cancelled Bookings</h2>
                    <p>{reports.cancelled_bookings}</p>
                  </div>

                  <div className="section">
                    <h2>Average Stay Duration</h2>
                    <p>{reports.average_stay_days} days</p>
                  </div>

                  <div className="section">
                    <h2>Top Room Types</h2>
                    <ul>
                      {reports.top_room_types &&
                      reports.top_room_types.length > 0 ? (
                        reports.top_room_types.map((room, i) => (
                          <li key={i}>
                            {room.room_type}: {room.count}
                          </li>
                        ))
                      ) : (
                        <li>No data</li>
                      )}
                    </ul>
                  </div>
                </div>
              </>
            ) : (
              <p>Loading...</p>
            )}
          </div>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default ReportsPage;
